import CommitmentPage from './our-commitment.component'

export default CommitmentPage
